import { defineApiActionTypes } from 'store/common/action-helpers';
const prefix = 'features/interests';

export const SET_USER_INTERESTS = defineApiActionTypes(`${prefix}/SET_USER_INTERESTS`);



// WEBPACK FOOTER //
// ./src/store/features/interests/action-types.js